/**
 * Created by Mark on 18/04/2017.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants/navigation.js';
import Action    from '../actions/default.js';

class NavigationService {

    constructor(){

    }

    fetchSideMenuComponents(){
        return ApplicationServices.call(Constants.GET_SIDE_MENU_COMPONENTS , {}).then(function(response){
            Action.update(Constants.UPDATE_SIDE_MENU_COMPONENTS , response);
        });
    }

    fetchMenuItems(){
        return ApplicationServices.call(Constants.GET_MENU_ITEMS , {}).then(function(response){
            Action.update(Constants.UPDATE_MENU_ITEMS_COMPONENTS , response.items);
        });
    }

}


export default new NavigationService();


// WEBPACK FOOTER //
// ./src/services/navigation-service.js